function getExpectedApiFilter({ item }) {
  return {
    // id: item.id || `tmp_id_${Date.now()}`,
    id: item.id,
    name: item.name,
    description: item.description,
    favorite: item.favorite,
    created_at: item.created_at,
    filter_type: item.filter_type,
    settings: {
      ...item.query,
    },
  }
}

const getInitialState = () => ({
  fss_selected_filter: null,
})
const state = getInitialState()

const getters = {
  fss_selected_filter: state => state.fss_selected_filter,
  // sff_custom_drills: (state, getters) => {
  //   let res = (getters.api_get_data('api_poker_saved_filters') || [])
  //   console.log(res)
  //   return res
  // },
}

const actions = {
  fss_setFilter(
    { state, commit, dispatch, getters },
    { namespace, item, method, hasMessage = true, hasExpectedResponse = false },
  ) {
    const l_item = {
      name: item.name,
      description: item.description,
      favorite: item.favorite,
      filter_type: item.filter_type,
      settings: {
        ...item.query,
      },
    }

    if (method === 'POST') {
      dispatch('api_saved_filter_post', {
        method: 'POST',
        data: l_item,
        hasMessage,
        namespace,
        // skipDuplicityCheck: true,
      })
    }
    if (method === 'PUT') {
      dispatch('api_saved_filter_put', {
        method: 'PUT',
        id: item.id,
        data: l_item,
        hasMessage,
        namespace,
        // skipDuplicityCheck: true,
      })
    }
    if (method === 'DELETE') {
      dispatch('api_saved_filter_delete', {
        method: 'DELETE',
        id: item.id,
        hasMessage,
        namespace,
        // skipDuplicityCheck: true,
      })
    }

    if (hasExpectedResponse) {
      // used in toggling favorite
      const expectedResponse = { status: 200, data: getExpectedApiFilter({ item }) }
      dispatch('handleSavedFilterUpdate', {
        // namespace,
        response: expectedResponse,
        method,
        id: item.id,
        hasMessage,
        hasExpectedResponse,
      })
    }
  },
  handleSavedFilterUpdate(
    { state, commit, dispatch, getters },
    { response, error, method, id, hasMessage, skipDuplicityCheck },
  ) {
    let status = response?.status
    if (status === 201 || status === 200 || status === 204) {
      const item = response.data
      let res = getters.api_get_data('api_poker_saved_filters')
      res = res.results || []

      let message = ''
      if (method === 'POST') {
        res = [item, ...res]
        message = 'success_filter_create'
      } else if (method === 'PUT') {
        res = res.map(i => {
          if (i.id === item.id) {
            return item
          }
          return i
        })
        message = 'success_filter_update'
      } else if (method === 'DELETE') {
        res = res.filter(i => i.id !== id)
        message = 'success_filter_delete'
      }

      commit('api_update_data', { key: 'api_poker_saved_filters', data: { results: res } })
      dispatch('globals_action', 'SavedFiltersTable')

      if (hasMessage) {
        dispatch('router_rm_dialog', 'save-filter-dialog')

        dispatch('messages', {
          type: 'success',
          status: 'success_message',
          statusMessages: {
            _success_message: {
              i18n: `messages.${message}`,
            },
          },
          hide: true,
        })
      }
    } else {
      let message = ''
      if (method === 'POST') {
        message = 'error_filter_create'
      } else if (method === 'PUT') {
        message = 'error_filter_update'
      } else if (method === 'DELETE') {
        message = 'error_filter_delete'
      }
      status = error?.response?.status

      dispatch('messages', {
        type: 'error',
        status: 'err_message',
        statusMessages: {
          _err_message: {
            i18n: `messages.${message}`,
            i18nParams: { status: status || 'unknown' },
          },
        },
      })
    }
  },
}
const mutations = {
  fss_reset(state, initialState = getInitialState()) {
    Object.assign(state, initialState)
  },
  fss_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
